// extracted by mini-css-extract-plugin
export var allArtwork = "AllArtworks-module--allArtwork--3g7Rg";